export const api = {
	//If on localhost url should be for local data
	url: window.location.href.includes("utoronto")
		? "https://brn.utoronto.ca"
		: window.location.href.includes("staging-001")
		? "https://brn.staging-001.dev"
		: "http://brn.local",
	endpoint: "wp-json/brnna/v1/network",
};
